/**
 * Utilitário de Select/Combo/Dropdown do eContador;
 * @class SelectUtils
 * @namespace SelectUtils
 */
class SelectUtils {
  /**
   * @hideconstructor
   */
  constructor() {
    this.defaultDTOConfig = {
      value: 'id',
      label: ['nome'],
      separator: ' - '
    };
  }

  /**
   * Converte listagem de dados em Objeto para componente
   * de Select.
   * @param {Array} lista - Lista de Objetos a ser Convertido
   * @param {Object} config - Objeto de configurações para conversão
   * @param {String} config.value - Chave que representa o valor do select
   * @param {Array<String>} config.label - Array de chaves para formar a label do campo
   * @param {String} config.separator - O divisor para ligar os valores da label
   * @method
   * @memberof SelectUtils
   * @return {Array<Object>} Retorna Array com objeto para componente de select;
   */
  ConverterDTOEmValoresParaSelect(lista, config = this.defaultDTOConfig) {
    if (!lista) return;
    config = { ...this.defaultDTOConfig, ...config };

    const options = [];

    lista.forEach((item) => {
      const value = Array.isArray(config.value)
        ? config.value.map((key) => this.adquireValorDeAtributoParaLabel(item, key)).join('')
        : item[config.value];
      const label = config.label.map((key) => this.adquireValorDeAtributoParaLabel(item, key)).join(config.separator);
      const option = {
        label,
        value
      };
      options.push(option);
    });

    return options;
  }

  /**
   * Busca dentro do item a chave informada. Pode receber uma String, ou uma Array
   * com o "caminho" até um subatribudo desejado.
   * @param {Object} item - DTO para conversão;
   * @param {String | Array} key - Chave para busca;
   * @returns {String} Retorna valor da chave buscada dentro do item;
   * @method
   * @memberof SelectUtils
   * @example
   * // retorna o id do item;
   * adquireValorDeAtributoParaLabel(item, 'id');
   * // retorna o nome do item dentro de atributos;
   * adquireValorDeAtributoParaLabel(item, ['atributos', 'nome']);
   */
  adquireValorDeAtributoParaLabel(item, key) {
    if (!item || !key) return;
    let label;
    if (Array.isArray(key)) {
      label = item;
      key.forEach((identificador) => {
        label = label[identificador];
      });
    } else {
      label = item[key];
    }

    return label;
  }
}

export const selectUtils = new SelectUtils();
